import bowser from 'bowser';

export default function browserCheck(done, hideIgnoreButton = false) {
    const defaultExpirationDuration = 1000 * 60 * 60 * 24 * 4; // 4 days
    const testingMode = location.hash === '#test-browsercheck';
    const getChromeUrl = 'https://www.google.com/chrome/browser/';

    const browsers = [
        {
            id: 'chrome',
            minVersion: '56',
            updateUrl: getChromeUrl,
            windows: true,
            mac: true
        },
        {
            id: 'safari',
            minVersion: '10',
            ios: true,
            minOsversion: '10.3.1',
            // 10.3.2 is latest
            // 10.2.1 is probably where the pouchdb bug is triggered
            alternatives: ['chrome', 'firefox'],
            updateUrl: 'https://support.apple.com/en-us/HT204204'
            // updateUrl_no: 'https://support.apple.com/no-no/HT204204'
        },
        {
            id: 'safari',
            minVersion: '9',
            mac: true,
            updateUrl: 'https://support.apple.com/en-us/HT204416'
            // updateUrl_no: 'https://support.apple.com/no-no/HT204416'
        },
        {
            id: 'firefox',
            minVersion: '51',
            updateUrl: 'https://www.mozilla.org/en-US/firefox/new/',
            windows: true,
            mac: true
        },
        // {
        //   id: 'msedge',
        //   minVersion: '13',
        //   updateUrl: 'https://www.microsoft.com/en-us/windows/microsoft-edge',
        //   windows: true
        // },
        {
            id: 'msie',
            notSupported: true,
            expirationDuration: 0
        }
    ];

    function checkBrowser(browser) {
        if (browser.minOsversion && bowser.compareVersions([bowser.osversion, browser.minOsversion]) === -1) {
            return false;
        }
        // return true
        // Not sure what this below line is
        return bowser.compareVersions([bowser.version, browser.minVersion]) > -1;
    }

    let browser = null;
    for (let i = 0; i < browsers.length; i++) {
        let b = browsers[i];
        if (b.ios && !bowser.ios) {
            continue;
        }
        if (bowser[b.id]) {
            browser = b;
            break;
        }
    }

    let alternativeBrowsers = browsers.filter(b => {
        if (b === browser) {
            return false;
        }
        return (b.windows && bowser.windows) || (b.mac && bowser.mac);
    });

    if (!browser) {
        browser = {};
        browser.expirationDuration = 0;
    }
    if (browser.expirationDuration === undefined) {
        browser.expirationDuration = defaultExpirationDuration;
    }

    if (!browser.id) {
        browser.notSupported = true;
    }

    if (!testingMode && (browser.notSupported ? false : checkBrowser(browser))) {
        return done();
    }

    let lastIgnoreTime = parseInt(localStorage.getItem('memolife-lastBrowserCheckIgnoreTimestamp') || 0, 10);
    let now = Date.now();
    if (!testingMode && lastIgnoreTime + browser.expirationDuration > now) {
        return done();
    }

    let t;
    const lang = 'no';
    if (lang === 'no') {
        t = {
            ignore: 'Ignorer',
            outdated: {
                update: 'Oppdater nettleseren',
                message: `Din nettleser (${bowser.name} ${bowser.version}) er utdatert. Oppdater nettleseren for beste opplevelse på dette nettstedet.`,
                alternativesText: 'Eller prøv en av disse nettleserne:'
            },
            notSupported: {
                message: `Hei, ${bowser.name} er ikke beste match for denne web-appen.`,
                // message: `Din nettleser (${bowser.name}) er ikke støttet.`,
                alternativesText:
                    'Vi anbefaler at du bruker en av disse nettleserne for den beste opplevelsen og sikkerheten:'
                // alternativesText: 'Vi foreslår at du bruker en av disse nettleserne for beste opplevelse på dette nettstedet:'
            }
        };
    } else {
        t = {
            ignore: 'Ignore',
            outdated: {
                update: 'Update browser',
                message: `Your web browser (${bowser.name} ${bowser.version}) is out of date. Update your browser for best experience on this site.`,
                alternativesText: 'Or use any of these supported browsers:'
            },
            notSupported: {
                message: `Hi, ${bowser.name} is not the best match for this web-app.`,
                // message: `Your web browser (${bowser.name}) is not supported.`,
                alternativesText: 'We recommend to use one of the browsers below for the best experience and safety:'
                // alternativesText: 'We suggest you use one of these browsers instead, for the best experience on this site:'
            }
        };
    }

    // browser.notSupported = true;

    let alternativesFragment = '';
    if (alternativeBrowsers.length) {
        if (browser.notSupported) {
            alternativesFragment = `<div class="BrowserWarning__alternativesText">${t.notSupported.alternativesText}</div>`;
        } else {
            alternativesFragment = `<div class="BrowserWarning__alternativesText">${t.outdated.alternativesText}</div>`;
        }
        alternativesFragment += '<div class="BrowserWarning__alternatives">';

        alternativesFragment += alternativeBrowsers
            .map(b => {
                return `
        <a class="BrowserWarning__alternative BrowserWarning__icon--${b.id}" href="${b.updateUrl}"></a>
      `;
            })
            .join('');

        alternativesFragment += '</div>';
    }

    if (browser.notSupported) {
        document.body.insertAdjacentHTML(
            'beforeend',
            `
      <div class="BrowserWarning ${hideIgnoreButton ? 'hideIgnoreButton' : ''}">
        <div class="BrowserWarning__messageBox">
          <div class="BrowserWarning__message">
            ${t.notSupported.message}
          </div>
          ${alternativesFragment}
        </div>
        <div class="BrowserWarning__ignoreButton">${t.ignore}</div>
      </div>
    `
        );
    } else {
        document.body.insertAdjacentHTML(
            'beforeend',
            `
      <div class="BrowserWarning ${hideIgnoreButton ? 'hideIgnoreButton' : ''}">
        <div class="BrowserWarning__messageBox">
          <div class="BrowserWarning__message">
            ${t.outdated.message}
          </div>
          <div class="BrowserWarning__icon BrowserWarning__icon--${browser.id}"></div>
          <div class="BrowserWarning__buttons">
            <a class="BrowserWarning__updateButton" href="${browser.updateUrl}">${t.outdated.update}</a>
          </div>
          ${alternativesFragment}
        </div>
        <div class="BrowserWarning__ignoreButton">${t.ignore}</div>
      </div>
    `
        );
    }

    let browserWarningElem = document.querySelector('.BrowserWarning');
    let browserWarningIgnoreButtonElem = document.querySelector('.BrowserWarning__ignoreButton');

    if (browserWarningIgnoreButtonElem) {
        browserWarningIgnoreButtonElem.onclick = function () {
            browserWarningElem.parentNode.removeChild(browserWarningElem);

            localStorage.setItem('memolife-lastBrowserCheckIgnoreTimestamp', '' + Date.now());
            return done();
        };
    }
}
